import React, { useMemo, useState } from 'react'

import PropTypes from 'prop-types'
import { Box, Button } from '@material-ui/core'

import { Autocomplete } from 'components'

import useStyles from './styles'

const SelectPlanActionField = ({
  options = [],
  stagedPlanActions = [],
  onStage,
  saving,
}) => {
  const [selectedPlanAction, setSelectedPlanAction] = useState(null)

  const classes = useStyles()

  const availableOptions = useMemo(() => {
    const stagedIds = stagedPlanActions.map((item) => item.evidencePlanActionId)

    return options.filter((option) => !stagedIds.includes(option.id))
  }, [options, stagedPlanActions])

  const handleStage = () => {
    if (!selectedPlanAction) return

    onStage({
      evidencePlanActionId: selectedPlanAction.id,
      name: selectedPlanAction.name,
    })
    setSelectedPlanAction(null)
  }

  return (
    <Box className={classes.row}>
      <Autocomplete
        className={classes.grow}
        options={availableOptions}
        value={selectedPlanAction}
        onChange={(_, value) => setSelectedPlanAction(value)}
        getOptionLabel={(option) => option?.name ?? ''}
        getOptionSelected={(option, value) => option.id === value?.id}
        textFieldProps={{
          label: 'Selecionar plano de ação',
          variant: 'outlined',
        }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleStage}
        disabled={!selectedPlanAction || saving}
      >
        Adicionar
      </Button>
    </Box>
  )
}

SelectPlanActionField.propTypes = {
  options: PropTypes.array,
  stagedPlanActions: PropTypes.array,
  onStage: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default SelectPlanActionField
